import { type ReactNode } from "react";
import NextLink from "next/link";

import { Link, Text } from "@cruk/cruk-react-components";

import { formatMoneyWithCommas } from "@fwa/src/utils/formatUtils";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";
import { memberTeamIconUrlForTheme } from "@fwa/src/utils/memberUtils";

import sharedStyles from "@fwa/src/components/styles.module.css";
import styles from "@fwa/src/components/MemberTeam/styles.module.css";

import { type TeamPageType } from "@fwa/src/types";

export function MemberTeam({
  teamPage,
  children,
}: {
  teamPage: TeamPageType;
  children: ReactNode;
}) {
  const raisedAmount = teamPage?.donationsTotalAmount
    ? formatMoneyWithCommas(teamPage?.donationsTotalAmount).replace(".00", "")
    : "0";
  const { title, url } = teamPage;
  const [brandName] = useBrandContext();

  const iconUrl = memberTeamIconUrlForTheme(brandName);

  return (
    <div className={styles["shadow-wrapper"]}>
      <NextLink
        href={`/team${url.slice(url.lastIndexOf("/"))}`}
        aria-label={title}
        title={title}
        data-cta-type="link-team"
      >
        <span className={styles["member-link-span"]}>
          <div
            className={sharedStyles["row"]}
            style={{ gap: "var(--spacing-xs, 8px)" }}
          >
            <div className={styles["profile-image-wrapper"]}>
              <img src={iconUrl} alt="" />
            </div>
            <div
              className={[styles["text-wrapper"], "spacing-props"].join(" ")}
              data-margin-left="xs"
            >
              <Text
                className={[
                  sharedStyles["single-line-ellipsis"],
                  "component-text",
                ].join(" ")}
                marginBottom="none"
              >
                <Link as="span">{`${title}`}</Link>
              </Text>
              <Text
                className={[
                  sharedStyles["single-line-ellipsis"],
                  "component-text",
                ].join(" ")}
                marginBottom="none"
              >
                {`£${raisedAmount} raised`}
              </Text>
            </div>
          </div>
        </span>
      </NextLink>
      {children}
    </div>
  );
}

export default MemberTeam;
